// 9fbef606107a605d69c0edbcd8029e5d
// stylelint-disable selector-max-specificity
// stylelint-disable max-nesting-depth

import { css } from 'styled-components';

const styles = css`
  .adyen-checkout__payment-method {
    border: none;
    background: none;
  }
  .adyen-checkout__payment-method__header {
    padding-left: 0 !important;
    padding-top: 0;
    padding-bottom: 28px !important;
  }
  .adyen-checkout__payment-method__radio {
    border: 1px solid #9b9b9b;
    background-color: #fff;
    height: 20px;
    width: 20px;
    box-sizing: content-box;
    display: block !important;
  }
  .adyen-checkout__payment-method__radio--selected:after {
    background: #000;
    height: 14px;
    width: 14px;
  }
  .adyen-checkout__payment-method:hover:not(.adyen-checkout__payment-method--selected)
    .adyen-checkout__payment-method__radio {
    box-shadow: none;
  }
  .adyen-checkout__payment-method__header__title {
    gap: 0px;
  }
  .adyen-checkout__payment-method__image__wrapper {
    margin-left: 8px;
    margin-right: 8px;
  }
  #dropin-container .adyen-checkout__paypal__buttons {
    width: 270px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    #dropin-container .adyen-checkout__paypal__buttons {
      width: 100%;
    }
  }

  #apple-pay-container .adyen-checkout__applepay__button {
    width: 200px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 100%;
      height: 42px;
    }
  }
  .adyen-checkout__payment-method__details__content {
    margin-bottom: 24px;
  }
  #dropin-container .adyen-checkout__applepay__button {
    width: 270px;
    border-radius: 4px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    #dropin-container .adyen-checkout__applepay__button {
      width: 100%;
    }
  }

  #dropin-container {
    .adyen-checkout__payment-method--paypal {
      ${(props) => (props.hidePaypal ? 'display:none;' : '')}
    }
    .adyen-checkout__payment-method--paypal .adyen-checkout__payment-method__image__wrapper,
    .adyen-checkout__payment-method--paypal .adyen-checkout__image {
      width: 90px;
      height: 22px;
      box-shadow: none;
      border: none;
    }

    .adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__image__wrapper {
      box-shadow: none;
      border: none;
      width: 90px;
      height: 22px;
      margin-left: -8px;
      .adyen-checkout__payment-method__image {
        width: 90px;
        height: 22px;
      }
    }

    .adyen-checkout__payment-method--paypal,
    .adyen-checkout__payment-method--applepay {
      .adyen-checkout__payment-method__name {
        display: none;
      }
    }
    .adyen-checkout__payment-method--googlepay {
      display: none;
    }
    .adyen-checkout__payment-method--credit {
      display: none;
    }

    .adyen-checkout__payment-method--applepay.adyen-checkout__payment-method--selected {
      .adyen-checkout__payment-method__details {
        padding-left: 0;
      }
    }
    .adyen-checkout__payment-method--paypal.adyen-checkout__payment-method--selected {
      .adyen-checkout__payment-method__details {
        padding-left: 0;
      }
      .adyen-checkout-pm-details-wrapper {
        position: relative;
        padding-top: 28px;
        padding-bottom: 12px;
        &:after {
          content: 'Your order will be placed directly from PayPal.';
          top: -18px;
          position: absolute;
          font-family: Nunito;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
  .adyen-checkout__paypal__button--paypal {
    margin-bottom: 0;
  }
  .adyen-checkout__payment-methods-list {
    gap: 0;
  }
`;

export default styles;
